export default __webpack_public_path__ + "8d790f8c03d2bc8be31079307974cdeb.svg";